import { Link } from 'react-router-dom';
import type { CatalogEntry } from '../games/catalog';
import { sound } from '../lib/audio';
import { playNextFor } from './PlayNext';

/**
 * "Try next": three small covers shown when a round ends (in the game bar for single-player games,
 * on the result panel for arcade and board games). Players who start a second game stay far longer.
 */
export function NextUp({ entry, count = 3, panel = false }: { entry: CatalogEntry; count?: number; panel?: boolean }) {
  return (
    <nav className={`next-up${panel ? ' next-up--panel' : ''}`} aria-label="Try another game">
      <span className="next-up__label">Try next</span>
      <ul>
        {playNextFor(entry, count).map((g) => (
          <li key={g.id}>
            <Link to={g.path} className="next-up__game" title={g.name} onClick={() => sound.unlock()}>
              {g.thumb ? <img src={g.thumb.replace('/covers/', '/covers-sm/')} alt="" width={400} height={300} loading="lazy" decoding="async" /> : <g.Icon />}
              <span className="next-up__name">{g.name}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
